import React from "react";

/** Multi-audio / language tracks manager. Tracks live under `ap.language_tracks`;
 *  the parent owns the helpers so we get a single source of truth for track state. */
export default function LanguageTracksPanel({ ap, addTrack, patchTrack, removeTrack }) {
  return (
    <>
          {/* Language tracks */}
          <div className="border-t border-zinc-800 pt-4" data-testid="language-tracks-section">
            <div className="flex items-baseline justify-between mb-3">
              <div className="font-display font-bold">Language tracks · Multi-audio</div>
              <button
                onClick={addTrack}
                data-testid="add-track-btn"
                className="font-mono text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm border border-zinc-700 hover:border-zinc-500 text-zinc-300"
              >
                + Add
              </button>
            </div>
            <div className="space-y-2">
              {(ap.language_tracks || []).map((t, i) => (
                <div key={t.id || i} className="grid grid-cols-[70px_minmax(0,1fr)_90px_100px_90px_60px_28px] gap-2 items-center" data-testid={`track-row-${i}`}>
                  <input
                    value={t.code}
                    onChange={(e) => patchTrack(i, { code: e.target.value })}
                    className="bg-black border border-zinc-800 rounded-sm px-2 py-1 font-mono text-xs uppercase"
                    placeholder="eng"
                    data-testid={`track-code-${i}`}
                  />
                  <input
                    value={t.name}
                    onChange={(e) => patchTrack(i, { name: e.target.value })}
                    className="bg-black border border-zinc-800 rounded-sm px-2 py-1 text-xs min-w-0 w-full"
                    placeholder="English 5.1"
                    data-testid={`track-name-${i}`}
                  />
                  <select
                    value={t.layout}
                    onChange={(e) => patchTrack(i, { layout: e.target.value })}
                    className="bg-black border border-zinc-800 rounded-sm px-2 py-1 font-mono text-xs"
                    data-testid={`track-layout-${i}`}
                  >
                    <option value="2.0">2.0</option>
                    <option value="5.1">5.1</option>
                    <option value="7.1">7.1</option>
                  </select>
                  <select
                    value={t.delivery_codec}
                    onChange={(e) => patchTrack(i, { delivery_codec: e.target.value })}
                    className="bg-black border border-zinc-800 rounded-sm px-2 py-1 font-mono text-xs"
                  >
                    <option value="AC-3">AC-3</option>
                    <option value="E-AC-3">E-AC-3</option>
                    <option value="AAC-LC">AAC-LC</option>
                    <option value="HE-AAC">HE-AAC</option>
                  </select>
                  <input
                    type="number"
                    value={t.delivery_bitrate_kbps}
                    onChange={(e) => patchTrack(i, { delivery_bitrate_kbps: Number(e.target.value) })}
                    className="bg-black border border-zinc-800 rounded-sm px-2 py-1 font-mono text-xs"
                    title="kbps"
                  />
                  <label className="flex items-center gap-1 text-[10px] text-zinc-400" title="Descriptive Video Service">
                    <input
                      type="checkbox"
                      checked={!!t.is_descriptive}
                      onChange={(e) => patchTrack(i, { is_descriptive: e.target.checked })}
                      className="accent-red-500"
                      data-testid={`track-dvs-${i}`}
                    />
                    DVS
                  </label>
                  <button
                    onClick={() => removeTrack(i)}
                    className="text-zinc-500 hover:text-red-400 font-mono text-xs"
                    data-testid={`track-remove-${i}`}
                    title="Remove track"
                  >
                    ×
                  </button>
                </div>
              ))}
              {(ap.language_tracks || []).length === 0 && (
                <div className="text-xs text-zinc-500 italic">No language tracks configured</div>
              )}
            </div>
          </div>

    </>
  );
}
